import React from "react";
import {
    Card,
    CardBody,
    CardTitle,
    ListGroup,
    ListGroupItem,
} from "reactstrap";

interface QuestionSectionProps {
    question: string;
    questionOptions?: string | null;
    answerText?: string | null;
    otherAnswerText?: string | null;
}

const QuestionSection = (props: QuestionSectionProps) => {

    return (
        <Card className="mb-3 shadow-sm">
            <CardBody>
                <CardTitle tag="h5">{props.question}</CardTitle>
                <ListGroup flush>
                    {props.questionOptions && props.questionOptions.length > 0 && (
                        <ListGroupItem>{props.questionOptions}</ListGroupItem>
                    )}
                    {props.answerText && props.answerText.length > 0 && (
                        <ListGroupItem>{props.answerText}</ListGroupItem>
                    )}
                    {props.otherAnswerText && props.otherAnswerText.length > 0 && (
                        <ListGroupItem>{props.otherAnswerText}</ListGroupItem>
                    )}
                </ListGroup>
            </CardBody>
        </Card>
    );
};

export default QuestionSection;
